export default __webpack_public_path__ + "static/media/Leaf.ca6037ec.png";